// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"438":"3190953e","651":"ef4fb145","858":"d24ab525"}[chunkId] + ".chunk.js";
};